import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import { buttonStyle, cardTitle, inputStyle, labelStyle, subtitle } from './quoteStyles';

const productOptions = [
  { value: 'home', label: 'Home Insurance' },
  { value: 'life', label: 'Life Insurance' },
  { value: 'car', label: 'Car Insurance' },
];

const CustomerStartQuote = () => {
  const navigate = useNavigate();
  const [productType, setProductType] = useState('home');

  const createApplication = async event => {
    event.preventDefault();

    const response = await fetch('/api/application/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productType }),
    });

    const data = await response.json();
    if (!response.ok) {
      alert(data.error || 'Unable to start quote request');
      return;
    }

    navigate(`/quote/${data.applicationId}/customer`);
  };

  return (
    <AppLayout>
      <h1 style={cardTitle}>Get A Quote</h1>
      <p style={subtitle}>Step 1 of 4: Select your insurance product.</p>

      <form onSubmit={createApplication} style={{ maxWidth: 480 }}>
        <label style={labelStyle}>Product type</label>
        <select
          value={productType}
          onChange={event => setProductType(event.target.value)}
          style={{ ...inputStyle, marginBottom: 16 }}
        >
          {productOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <button type="submit" style={buttonStyle}>
          Continue
        </button>
      </form>
    </AppLayout>
  );
};

export default CustomerStartQuote;
